<template>
  <q-layout view="lHh Lpr fFf">
    <q-header class="bg-tjpa-blue z-top">
      <q-toolbar>
        <div class="column ">
          <span class="row inline cursor-pointer">
            <q-toolbar-title @click="goHome"> {{ pageTitle }} </q-toolbar-title>
          </span>
        </div>
        <q-space />
        <tjpa-user-menu v-show="admin"/>
      </q-toolbar>
    </q-header>
    <tjpa-demandas-drawer />

    <q-page-container>
      <router-view />
    </q-page-container>

    <q-footer class="bg-tjpa-blue" flat style="height: 80px">
      <q-img
        class="q-ml-md cursor-pointer absolute-center"
        @click="goPortal"
        src="./assets/selo-tj-white-full.png"
        fit="fill"
        style="height: 80px; width: 200px"
      />
      <q-space />
    </q-footer>
  </q-layout>
</template>

<script setup>
import tjpaUserMenu from "./components/tjpa-user-menu.vue";
import tjpaDemandasDrawer from "./components/tjpa-demandas-drawer.vue";
import { useUserStore } from "@/store/user-store";
import { useRouter } from "vue-router";
import {computed} from 'vue'
import { loadPromise, getKeycloak } from '@/config/keycloak'

const router = useRouter();

const goHome = () => router.push("/");

const goPortal = () =>
  (window.location.href = "https://www.tjpa.jus.br/PortalExterno/");
window.location.pathname == '/login' && (async () => {await loadPromise;getKeycloak()?.login()})();
const userstore = useUserStore()
const admin = computed(() => userstore.admin)

const pageTitle = computed(() => {
  const defaultTitle = 'TJPA'
  return router.currentRoute.value.meta.title || defaultTitle
})
</script>


<style lang="scss">
@import "./styles/quasar.variables.sass";
.bg-tjpa-blue {
  background: $tjpa-blue;
}

@media (hover: hover) and (pointer: fine) {
  .q-drawer__opener.fixed-right {
    display: none;
  }
}
</style>
